import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DataCtx = createContext(null);

export function DataProvider({ children }) {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [rootTitle, setRootTitle] = useState("");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [cfg, objs] = await Promise.all([api.getConfig(), api.getObjects()]);
      setCategories(cfg.data.categories || []);
      setRootTitle(cfg.data.title || "");
      setItems(objs.data.items || []);
    } catch (e) {
      // keep previous state on failure
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // /, /test and /iot are self-contained and do not use the shared MWS tree.
    const p = typeof window !== "undefined" ? window.location.pathname : "";
    if (p === "/" || p.includes("/test") || p.includes("/iot")) {
      setLoading(false);
      return;
    }
    load();
  }, [load]);

  return (
    <DataCtx.Provider value={{ items, categories, rootTitle, loading, reload: load }}>
      {children}
    </DataCtx.Provider>
  );
}

export const useData = () => useContext(DataCtx);
